// extracted by mini-css-extract-plugin
export default {"dividerClass":"style-module--dividerClass--tfmqN"};